import { ColorValueObject, HoneycombThemeBase } from '../types';
import { resolveColorValue } from './resolveColorValue';

export function resolveFlatColorObject(theme: HoneycombThemeBase) {
    return (colors: ColorValueObject) => {
        const entries = Object.keys(colors).map((key) => {
            return [key, resolveColorValue(theme)(colors[key])];
        });
        return Object.fromEntries(entries);
    };
}
